import type { BillingCycle, EmploymentType, ProjectAccessRole, SkillGrade, SolutionCategory, SolutionItem } from "@/engine/types";
import type { FuiOption } from "@/components/fui-control";

export const EMPLOYMENT_LABEL: Record<EmploymentType, string> = {
  permanent: "정규직",
  freelance: "프리랜서",
  contract: "계약직",
  partner: "외주협력사",
};
export const EMPLOYMENT_COLOR: Record<EmploymentType, "brand" | "informative" | "subtle" | "important"> = {
  permanent: "brand",
  freelance: "informative",
  contract: "subtle",
  partner: "important",
};
export const EMPLOYMENT_OPTIONS: FuiOption[] = (Object.keys(EMPLOYMENT_LABEL) as EmploymentType[]).map((v) => ({ value: v, label: EMPLOYMENT_LABEL[v] }));

export const GRADE_LABEL: Record<SkillGrade, string> = {
  principal: "특급기술자",
  senior: "고급기술자",
  mid: "중급기술자",
  junior: "초급기술자",
  specialist: "전문기술위원",
};
export const GRADE_OPTIONS: FuiOption[] = (Object.keys(GRADE_LABEL) as SkillGrade[]).map((v) => ({ value: v, label: GRADE_LABEL[v] }));

export const ACCESS_ROLE_LABEL: Record<ProjectAccessRole, string> = {
  admin: "관리자",
  pm: "PM (사업책임자)",
  pl: "PL (파트리더)",
  member: "팀원",
  viewer: "뷰어",
};
export const ACCESS_ROLE_OPTIONS: FuiOption[] = (["pm", "pl", "member", "viewer"] as ProjectAccessRole[]).map((v) => ({ value: v, label: ACCESS_ROLE_LABEL[v] }));

export const ALLOCATION_PRESETS: Array<{ value: number; label: string }> = [
  { value: 1, label: "100%" },
  { value: 0.8, label: "80%" },
  { value: 0.6, label: "60%" },
  { value: 0.5, label: "50%" },
  { value: 0.3, label: "30%" },
  { value: 0.2, label: "20%" },
];

export const SOLUTION_CATEGORY_LABEL: Record<SolutionCategory, string> = {
  software: "소프트웨어",
  cloud: "클라우드 인프라",
  saas: "SaaS 구독",
  license: "보안·연계 라이선스",
  hardware: "하드웨어·장비",
};
export const SOLUTION_CATEGORY_COLOR: Record<SolutionCategory, "brand" | "informative" | "warning" | "subtle" | "success" | "severe"> = {
  software: "brand",
  cloud: "informative",
  saas: "success",
  license: "warning",
  hardware: "subtle",
};
export const SOLUTION_CATEGORY_OPTIONS: FuiOption[] = (Object.keys(SOLUTION_CATEGORY_LABEL) as SolutionCategory[]).map((v) => ({ value: v, label: SOLUTION_CATEGORY_LABEL[v] }));

export const BILLING_CYCLE_LABEL: Record<BillingCycle, string> = {
  once: "일시불",
  monthly: "월 구독",
  yearly: "연간 라이선스",
};
export const BILLING_CYCLE_OPTIONS: FuiOption[] = (Object.keys(BILLING_CYCLE_LABEL) as BillingCycle[]).map((v) => ({ value: v, label: BILLING_CYCLE_LABEL[v] }));

export const SOLUTION_STATUS_LABEL: Record<SolutionItem["status"], string> = {
  planned: "예정",
  contracted: "계약",
  active: "운영",
  terminated: "종료",
};
export const SOLUTION_STATUS_OPTIONS: FuiOption[] = (["planned", "contracted", "active", "terminated"] as const).map((v) => ({
  value: v,
  label: SOLUTION_STATUS_LABEL[v],
}));

/** 15 curated team accent colors (3x5 palette). */
export const TEAM_COLORS: Array<{ value: string; label: string }> = [
  // 1행
  { value: "#397dd5", label: "스카이블루" },
  { value: "#3061d6", label: "블루" },
  { value: "#20337a", label: "네이비" },
  { value: "#be3528", label: "레드" },
  { value: "#da5978", label: "핑크" },
  // 2행
  { value: "#f18e35", label: "오렌지" },
  { value: "#3a8a52", label: "그린" },
  { value: "#7ca645", label: "라임" },
  { value: "#9ca12b", label: "올리브" },
  { value: "#69bab5", label: "틸" },
  // 3행
  { value: "#9649b0", label: "퍼플" },
  { value: "#77488d", label: "딥퍼플" },
  { value: "#6f7cc0", label: "라벤더" },
  { value: "#825424", label: "브라운" },
  { value: "#5b5b5b", label: "그레이" },
];
